import {
  Module,
  VuexModule,
  getModule,
  Mutation,
} from "vuex-module-decorators";

import { ProjectDetails } from "@/data/models/ProjectDetails";

const name = "projectDetails";

import store from "@/store";
import { ClientPanelAssignment } from "@/data/models/ClientPanelAssignment";
import Report from "@/data/models/Report";
import { ProjectDetailsTab } from "@/data/models/ProjectDetailsTab";
import { GenericDeviceProjectAssignment } from "@/data/models/GenericDeviceAssignment";

if (store.state[name]) {
  store.unregisterModule(name);
}

interface ProjectDetailsState {
  projectDetails: ProjectDetails;
  clientPanelAssignments: Array<ClientPanelAssignment>;
  genericDeviceAssignments: Array<GenericDeviceProjectAssignment>;
  reports: Array<Report>;
  projectDetailsTab: ProjectDetailsTab;
}

@Module({ dynamic: true, namespaced: true, store, name: name })
export class ProjectDetailsVuexModule extends VuexModule {
  projectDetailsState: null | ProjectDetailsState = null;

  @Mutation
  cacheProjectDetailsState(projectDetailsState: ProjectDetailsState | null) {
    this.projectDetailsState = projectDetailsState;
  }

  @Mutation
  clearProjectDetailsState() {
    this.projectDetailsState = null;
  }
}

export const ProjectDetailsModule = getModule(ProjectDetailsVuexModule);
